import DisplayTime from '@/components/site/parts/DisplayTime.vue'
import Paginate from '@/components/site/parts/PaginatePublic.vue'
import PostTitle from '@/components/posts/PostTitle.vue'
import PostView from '@/pages/posts/PostView.vue'
import PostViewMobile from '@/mobile/pages/post/PostView.vue'
export const postSearch= { 
    name:'mobile_post_search',  
    data(){
        return{
            isLoading:true
        }
    },
    props:[
        'user_id','search','id'
    ],
   
    components:{
        DisplayTime,
        Paginate,
        PostTitle,
        PostView,PostViewMobile
    }, 
    mounted(){
        this.fetchLists();
    },
    watch:{
        search(data)
        {
            //alert(roomid);
            if(data)
            {
               this.fetchLists();
            }
        }
    },
    computed:{
        postlists:{            
            get(){                 
                return this.$store.state.posts.postsdata;
            }
        },
        searchpost_user_id()
        {
            return this.$store.getters['menu/getSearchPostUserId'];
        },
        searchpost_content()
        {
            return this.$store.getters['menu/getSearchPostContent'];
        }
    },
    methods:{
        test(data){
            alert(data);
        },
        async fetchLists(pagenumber) 
        {      
            const _user_id =  this.search?'':(this.user_id?this.user_id:this.searchpost_user_id);
            const _search =  this.user_id?'':(this.search?this.search:this.searchpost_content);   
            const formData = {               
                user_id:_user_id,
                search:_search,
                page:pagenumber?pagenumber:1,
                popup:false
            }
            //alert(_user_id+"/"+ _search);
            try {
                const response = await this.$store.dispatch("posts/getSearchPosts", formData)
                console.log(response);
                this.postlists = response.data.reverse();
                //vuex 에 검색 인자 저장
                this.$store.commit('menu/setSearchpost_userId', _user_id);
                this.$store.commit('menu/setSearchpost_content', _search);
                
                //console.log("안나오는듯",this.postlists.data.length);          
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
    }
}